'use strict'

export const COMPANY_READER_ROLE_CODE = 1 // 专门读取公司信息及老板信息的角色



// WEBPACK FOOTER //
// ./src/constants/roleCode.js